import axios from '@/plugins/axiosInstance'
import { socialMedia } from '@/networking/urlManager'

/**
 * Handles OAuth callback data for platform connection
 * @param {Object} data - OAuth response data
 * @param {string} redirectURL - Redirect URL
 * @param {string} assetId - The asset ID
 * @param {number} platformId - ID of the platform
 * @returns {Promise<Object>} API response
 */
export const handleOAuth = async (data, redirectURL, assetId, platformId) => {
  try {
    const response = await axios.post(socialMedia.socialOauth, {
      data,
      redirectURL,
      assetId,
      platformId,
    })
    return response.data
  } catch (error) {
    // Duplicate account hatalarını yakalayıp özelleştirilmiş nesne dön
    if (error.response && error.response.status === 409) {
      // Duplicate account durumunda özel hata objesi dön
      return {
        success: false,
        isDuplicate: true,
        error: error.response.data.error || error.response.data.message || 'Bu hesap zaten bağlı',
        message: error.response.data.message || 'Bu Google hesabı zaten bu workspace\'e bağlı',
        emailAddress: error.response.data.emailAddress,
        accountId: error.response.data.accountId || null
      }
    }
    
    // Diğer hataları normal şekilde fırlat
    throw error
  }
}
